/**
 * AutoRefreshIndicator — Phase 43.7
 *
 * Indicatore visibile "Aggiornato HH:MM:SS · auto ogni Xs" con bottone
 * di refresh manuale. Conferma all'utente che la pagina è viva e si sta
 * aggiornando da sola.
 *
 * Props:
 *   lastUpdated: Date | null
 *   intervalSec: number (es. 30)
 *   onRefresh: () => Promise<void>
 *   loading: boolean (refresh manuale in corso)
 */
import { useEffect, useState } from "react";
import { RefreshCcw, Loader2 } from "lucide-react";

function _hms(d) {
  if (!d) return "—";
  return d.toLocaleTimeString("it-CH", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
}

export default function AutoRefreshIndicator({
  lastUpdated,
  intervalSec = 30,
  onRefresh,
  loading = false,
  className = "",
}) {
  // Tick ogni 1s per aggiornare "X secondi fa"
  const [, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((x) => x + 1), 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      className={`inline-flex items-center gap-2 text-[11px] text-dapnow-muted ${className}`}
      data-testid="auto-refresh-indicator"
    >
      <span data-testid="auto-refresh-last">
        Aggiornato {_hms(lastUpdated)} · auto ogni {intervalSec}s
      </span>
      <button
        type="button"
        onClick={onRefresh}
        disabled={loading}
        data-testid="auto-refresh-btn"
        className="inline-flex items-center gap-1 rounded-full border border-dapnow-line bg-white px-2.5 py-1 font-bold hover:border-dapnow-blue/40 disabled:opacity-60"
      >
        {loading ? <Loader2 className="h-3 w-3 animate-spin" /> : <RefreshCcw className="h-3 w-3" />}
        Aggiorna
      </button>
    </div>
  );
}
